export const CATEGORIES = ["executive", "platform", "operational", "venture", "board", "fractional"];

export const EMPLOYMENT_TYPES = [
  { v: "full_time", l: "Full-time" },
  { v: "part_time", l: "Part-time" },
  { v: "contract", l: "Contract" },
  { v: "fractional", l: "Fractional" },
  { v: "advisory", l: "Advisory" },
];

export const ARRANGEMENTS = [
  { v: "remote", l: "Remote" },
  { v: "hybrid", l: "Hybrid" },
  { v: "onsite", l: "On-site" },
];

export const SENIORITY = [
  { v: "board_chair", l: "Board Chair" },
  { v: "board_director", l: "Board Director" },
  { v: "ceo", l: "CEO / Founder" },
  { v: "c_suite", l: "C-Suite (CxO)" },
  { v: "evp", l: "EVP" },
  { v: "svp", l: "SVP" },
  { v: "vp", l: "VP" },
  { v: "director", l: "Director / Head of" },
  { v: "principal", l: "Principal / Senior IC" },
  { v: "manager", l: "Manager / Lead" },
  { v: "fractional", l: "Fractional executive" },
  { v: "advisor", l: "Advisor" },
];

export const labelOf = (list, v) => (list.find((x) => x.v === v)?.l) || (v || "").replace(/_/g, " ");

export const emptyJobFields = {
  role_category: "executive",
  employment_type: "full_time",
  work_arrangement: "remote",
  seniority: "",
  location: "",
  compensation_range: "",
  responsibilities: "",
  requirements: "",
  application_deadline: "",
  apply_method: "portal",
  apply_link: "",
};
